import { render, staticRenderFns } from "./EGBPage.vue?vue&type=template&id=64ad2d3c&"
import script from "./EGBPage.vue?vue&type=script&lang=js&"
export * from "./EGBPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports